import React, { useRef, useState } from 'react'
import { DropMenu } from '@roo/roo'

interface MenuOption {
  label: string
  value: string | number
}

interface DropdownMenuProps {
  children: React.ReactNode
  menu: MenuOption[]
  onItemClick: (item: MenuOption) => void
}

const ClickDropdownMenu: React.FC<DropdownMenuProps> = ({
  children,
  menu,
  onItemClick,
}) => {
  const [visible, setVisible] = useState(false)

  function changeVisible (visible: boolean) {
    setVisible(visible)

  }

  const handleItemClick = (item: MenuOption) => {
    setVisible(false)
    onItemClick(item)
  }

  return (
    <DropMenu
      menu={menu}
      onItemClick={handleItemClick}
      trigger="click"
      onClickOutside={(e) => {
        e.stopPropagation() // 会与 onClickOutside 同时触发,优先支持这里
        setVisible(false)
      }}
      visible={visible}
    >
      <div
        onClick={(e) => { //
          setVisible(!visible)
        }}>
        {children}
      </div>
    </DropMenu>
  )
}

export default ClickDropdownMenu
